{/* <i class="fa-regular fa-wifi"></i> */ }
{/* <i class="fa-regular fa-wifi-slash"></i> */ }
let icowifi = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:18px" class="mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M8.288 15.038a5.25 5.25 0 0 1 7.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 0 1 1.06 0Z" /></svg>';

function updateConnectionOnline(e) {
    // console.error('updateConnectionOnline()', {
    //     e: e,
    //     'navigator.onLine': navigator.onLine,
    // })
    if (navigator.onLine) {
        window.pe.$root.$refs.snackbar.show(`${icowifi} Vous êtes connecté au réseau`, 'success');
        $('#alert-offline').css({ display: 'none' });
    } else {
        window.pe.$root.$refs.snackbar.show(`${icowifi} Connexion réseau a été perdue`, 'danger', true);
        $('#alert-offline').css({ display: 'block' });
    }
}
window.addEventListener("online", updateConnectionOnline);
window.addEventListener("offline", updateConnectionOnline);

// https://developer.mozilla.org/en-US/docs/Web/API/Network_Information_API
// https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers
if (navigator.connection) {
    let type = navigator.connection?.effectiveType;
    function updateConnectionStatus() {
        // if (type != navigator.connection.effectiveType){
        console.info(
            `Connection type changed from ${type} to ${navigator.connection.effectiveType}`,
        );
        // }
        type = navigator.connection.effectiveType;
    }
    navigator.connection.addEventListener("change", updateConnectionStatus);
}

// let preloadVideo = true;
// const connection = navigator.connection;
// if (connection) {
//     if (connection.effectiveType === "slow-2g") {
//         preloadVideo = false;
//     }
// }
